import { formatNumber } from "helpers/system";
import React from "react";

const DriversTable = ({ data }) => {
    return (
        <table className="table table-sm">
            <thead>
                <tr>
                    <th>ФИО</th>
                    <th>Статья расхода/дохода</th>
                    <th>Сумма</th>
                </tr>
            </thead>
            <tbody>
                {data?.length ? (
                    data.map((el, index) => {
                        return (
                            <tr key={index}>
                                <td>{el.driverName}</td>
                                <td>{el.name}</td>
                                <td>
                                    {formatNumber(el.value, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </td>
                            </tr>
                        );
                    })
                ) : (
                    <tr>
                        <td colSpan={3} className="text-center">
                            Нет данных
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
};

export default DriversTable;
